import React, {Component} from 'react';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardFooter, Table, Button } from 'reactstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';

import ProductSearch from '../../components/Product/Search';

import Config from '../../config';

import './Daterangepicker.css';
import './Productlist.css';

class OrderList extends Component {
 constructor(props) {
  super(props);

  this.state = {
   pid: 0,
   start: moment().subtract(6, 'days').format('YYYY-MM-DD'),
   end: moment().format('YYYY-MM-DD'),
   orders: []
  }

  this.downloadInvoice = this.downloadInvoice.bind(this);
 }

 getOrders() {
  this.props.reqAPI(Config.apiURI+'/api/orders/invoices', 'POST', {
   pid: this.state.pid,
   start: this.state.start,
   end: this.state.end
  }).then((orders) => {
   this.setState({orders});
  }).catch((error) => {
   console.log(error);
  })
 }

 downloadInvoice(id) {
  this.props.reqAPI(Config.apiURI+'/api/pdf/invoice?id='+id).then(data => {
   const downloadLink = document.createElement("a");
   downloadLink.href = `data:application/pdf;base64,${data.base64}`;
   downloadLink.download = "Factura-"+data.number.replace('/','.')+".pdf";
   downloadLink.click();
  }, err => {
   console.log(err);
  })
 }

 componentWillMount() {
  this.getOrders();
 }

 render() {
  if(this.state.start === this.state.end) {
   var humanDate = new Date(Date.parse(this.state.start)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  } else {
   var humanDate = new Date(Date.parse(this.state.start)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
   humanDate += ' - ' + new Date(Date.parse(this.state.end)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  return (
   <section>
    <Card>
     <CardBody>
      <Row>
       <Col sm="10">
        <CardTitle className="mb-0">Resumen de facturación</CardTitle>
        <div className="small text-muted font-weight-bold">{humanDate}</div>
       </Col>
       <Col sm="2" className="d-none d-sm-inline-block">
        <Button className="float-right" title="Reset" onClick={() => {
         this.setState({
          pid: 0,
          start: moment().subtract(6, 'days').format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD'),
          orders: []
         }, this.getOrders);
        }}><i className="fa fa-refresh"></i></Button>
        <DateRangePicker containerStyles={{'float':'right'}}
         opens="left"
         startDate={moment()}
         endDate={moment()}
         ranges={{
          'Hoy': [moment(), moment()],
          'Esta semana': [moment().startOf('week').add(1, 'days'), moment().endOf('week').add(1, 'days')],
          'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
          'Este mes': [moment().startOf('month'), moment().endOf('month')],
          'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
          'Este año': [moment().startOf('year'), moment().endOf('year')]
         }}
         locale={{
          format: 'DD/MM/YYYY',
          applyLabel: "Aplicar",
          cancelLabel: "Cancelar",
          customRangeLabel: "Personalizado",
          fromLabel: "De",
          toLabel: "a",
          weekLabel: "W",
          daysOfWeek: [ "Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do" ],
          monthNames: [ "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre" ],
          firstDay: 1
         }}
         onApply={(e, picker) => {
          this.setState({
           start: picker.startDate.format('YYYY-MM-DD'),
           end: picker.endDate.format('YYYY-MM-DD')
          }, this.getOrders);
         }}>
         <Button color="primary"><i className="fa fa-calendar"></i></Button>
        </DateRangePicker>
       </Col>
      </Row>
     </CardBody>

     <CardFooter>
      <ProductSearch reqAPI={this.props.reqAPI} handleInputEL={() => {}} handleCallback={(e) => { this.setState({pid: e.ID}, this.getOrders) }} />
     </CardFooter>
    </Card>

    {this.state.orders.length > 0 ?
    this.state.orders.map((order, i) => (
    <Card key={i}>
     <CardHeader>
      <strong>{order.FID}</strong> <small>{new Date(Date.parse(order.date)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</small>
      <div className="card-actions bg-light">
       <Button disabled><i className={order.payment === '0'?'fa fa-credit-card-alt':'fa fa-money'}></i></Button>
       <Button onClick={() => this.downloadInvoice(order.ID)}><i className="fa fa-file-pdf-o"></i></Button>
      </div>
     </CardHeader>

     <Table className="productList">
      <thead>
       <tr>
        <th className="name">Producto</th>
        <th className="quantity">Cantidad</th>
        <th className="amount">Precio por unidad</th>
        <th className="price">Precio del lote</th>
       </tr>
      </thead>
      <tbody className={order.type === '0'?'text-danger':'text-success'}>
       {order.items.map((item, i) => (
       <tr key={i}>
        <td className="name text-dark">{item.notes ? item.name + ' - '+item.notes : item.name}</td>
        <td className="quantity">{item.quantity}</td>
        <td className="amount">{parseFloat(item.price / item.quantity).toFixed(2)}€</td>
        <td className="price">{parseFloat(item.price).toFixed(2)}€</td>
       </tr>
       ))}
      </tbody>
     </Table>

     <CardFooter>
      <Row>
       <Col md="10">
        <strong>{order.comment !== ''? 'Observaciones':''}</strong><br />
        {order.comment}
       </Col>
       <Col md="2" className="text-right">
        <span style={{fontSize: '150%'}} className={order.type === '0'?'text-danger':'text-success'}>{parseFloat(order.total).toFixed(2)}€</span>
       </Col>
      </Row>
     </CardFooter>
    </Card>
    ))
    :
    <Container>
     <Row className="justify-content-center">
      <Col md="6">
       <div className="clearfix">
        <p className="text-muted text-center">No se ha encontrado ninguna factura {this.state.start == this.state.end?'en la fecha seleccionada':'entre las fechas seleccionadas'}.</p>
       </div>
      </Col>
     </Row>
    </Container>
    }
   </section>
  )
 }
}

export default OrderList;



// WEBPACK FOOTER //
// ./src/views/Orders/Invoice.js